import {
  shouldApplyPendingAuthorizationGate,
  refreshEnforceAuthorizationSetting,
  enforcePendingAuthorizationGate,
} from "@/utils/pendingAuthorizationGate";

export async function runPendingAuthorizationGuard(routeTo) {
  if (!shouldApplyPendingAuthorizationGate(routeTo)) {
    return null;
  }

  await refreshEnforceAuthorizationSetting();
  return enforcePendingAuthorizationGate(null);
}
